module.exports = __webpack_public_path__ + "img/bookshelf_mid.160599b1.png";